(() => {
  if (window.ebarritoCommunityInstalled) return;
  window.ebarritoCommunityInstalled = true;
  const start = () => {
    const root = document.querySelector('[data-community-controller]');
    if (!root) return;
    const key = `ebarrito-community:${root.dataset.theme}:`;
    const read = name => { try { return sessionStorage.getItem(key + name); } catch { return null; } };
    const write = (name, value) => { try { sessionStorage.setItem(key + name, value); } catch {} };
    const readMember = () => { try { return localStorage.getItem(key + 'member') === '1' || read('member') === '1'; } catch { return read('member') === '1'; } };
    let storageAvailable = false;
    try { sessionStorage.setItem(key + 'check', '1'); sessionStorage.removeItem(key + 'check'); storageAvailable = true; } catch {}
    const dialog = document.getElementById('EbarritoCommunityDialog');
    const page = document.querySelector('[data-community][data-mode="page"]');
    let member = root.dataset.member === 'true' || readMember();
    let shown = read('shown') === '1';
    let returnFocus = null;
    let timer;
    let ready = false;
    const markShown = () => { shown = true; write('shown', '1'); clearTimeout(timer); };
    const markMember = () => {
      member = true;
      write('member', '1');
      try { localStorage.setItem(key + 'member', '1'); } catch {}
      markShown();
      document.documentElement.classList.add('eb-community-session-member');
      document.querySelectorAll('[data-community-bar], [data-community-invitation], [data-eb-community-open]').forEach(node => {
        (node.closest('li') || node).hidden = true;
      });
      document.querySelectorAll('[data-community]').forEach(panel => {
        if (panel.dataset.communityState === 'success') return;
        const form = panel.querySelector('[data-community-form-wrap]');
        const result = panel.querySelector('[data-community-member-result]');
        if (form && result) { form.hidden = true; result.hidden = false; }
      });
    };
    const open = trigger => {
      if (member) return true;
      const drawer = trigger?.closest('header-drawer');
      if (drawer && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(new Event('click'));
      if (page) {
        page.scrollIntoView({block:'center', behavior:'smooth'});
        page.querySelector('h2')?.focus({preventScroll:true});
        markShown();
        return true;
      }
      if (!dialog || typeof dialog.showModal !== 'function') return false;
      if (dialog.open) return true;
      returnFocus = trigger || document.activeElement;
      dialog.showModal();
      markShown();
      document.body.classList.add('eb-community-open');
      const result = [...dialog.querySelectorAll('[data-community-result]')].find(node => !node.closest('[hidden]'));
      (result || dialog.querySelector('[data-community-close]'))?.focus({preventScroll:true});
      return true;
    };
    const close = () => { if (dialog?.open) dialog.close(); };
    dialog?.addEventListener('close', () => {
      document.body.classList.remove('eb-community-open');
      markShown();
      if (location.hash === '#community') {
        const url = new URL(location.href); url.hash = '';
        history.replaceState(history.state, '', url);
      }
      if (returnFocus?.isConnected && returnFocus.getClientRects().length && !returnFocus.closest('[hidden]')) returnFocus.focus({preventScroll:true});
      else document.getElementById('MainContent')?.focus({preventScroll:true});
    });
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-eb-community-open]');
      if (trigger) {
        if (!event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && open(trigger)) event.preventDefault();
        return;
      }
      if (event.target.closest('[data-community-close]')) return close();
      if (event.target.closest('[data-community-retry]')) return location.reload();
      if (event.target.closest('[data-community-continue]') && event.target.closest('dialog')) {
        event.preventDefault(); return close();
      }
      if (dialog && event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      }
    });
    if (member) markMember();
    if (page) markShown();
    const canAutoOpen = root.dataset.autoOpen === 'true' && storageAvailable && !member && !shown && !page;
    const blockedByInteraction = () => document.visibilityState === 'hidden' ||
      document.querySelector('dialog[open], details[open], cart-drawer.active, .iubenda-cs-visible') ||
      document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
    const attemptAutoOpen = () => {
      if (member || shown || !ready) return;
      if (blockedByInteraction()) { timer = setTimeout(attemptAutoOpen, 2000); return; }
      open(null);
    };
    let autoDue = false;
    if (canAutoOpen) timer = setTimeout(() => { autoDue = true; attemptAutoOpen(); }, Number(root.dataset.delay || 10) * 1000);
    const normalize = text => (text || '').normalize('NFKC').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
    document.querySelectorAll('[data-community-forms]').forEach(container => {
      const panel = container.closest('[data-community]');
      const loading = panel.querySelector('[data-community-loading]');
      const unavailable = panel.querySelector('[data-community-unavailable]');
      const title = panel.querySelector('.eb-community__title');
      const observed = new WeakSet();
      const observers = [];
      let completed = false;
      let loaded = false;
      const timeout = setTimeout(() => {
        if (!loaded && !member) { loading.hidden = true; unavailable.hidden = false; }
      }, 12000);
      const scan = () => {
        if (completed) return;
        const roots = [];
        const walk = scope => {
          roots.push(scope);
          if (scope.host && scope.querySelector('input:is(#first_name,#last_name,#email)') && !scope.querySelector('[data-ebarrito-field-labels]')) {
            const style = document.createElement('style');
            style.dataset.ebarritoFieldLabels = '';
            style.textContent = `
              input:is(#first_name,#last_name,#email) {
                box-sizing: border-box !important;
                min-height: 60px !important;
                padding: 26px 12px 8px !important;
                font-size: 16px !important;
                line-height: 24px !important;
              }
              input:is(#first_name,#last_name,#email) + label {
                position: absolute !important;
                top: 7px !important; left: 12px !important;
                right: 12px !important; bottom: auto !important;
                transform: none !important;
                display: block !important; visibility: visible !important;
                opacity: 1 !important; transition: none !important;
                font-size: 12px !important; line-height: 16px !important;
                text-align: left !important; pointer-events: none !important;
                color: #263c2d !important;
              }
            `;
            scope.appendChild(style);
          }
          if (!observed.has(scope)) {
            observed.add(scope);
            const observer = new MutationObserver(scan);
            observer.observe(scope, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['data-current-step','hidden','aria-hidden']});
            observers.push(observer);
          }
          scope.querySelectorAll('*').forEach(node => { if (node.shadowRoot) walk(node.shadowRoot); });
        };
        walk(container);
        const inputs = roots.some(scope => scope.querySelector('input:not([type="hidden"]), textarea, select'));
        const expected = normalize(container.dataset.successHeading);
        const successHeading = roots.flatMap(scope => [...scope.querySelectorAll('h1,h2,h3,[role="heading"]')])
          .find(node => normalize(node.textContent) === expected && !node.closest('[hidden],[aria-hidden="true"]'));
        const successBanner = roots.some(scope => [...scope.querySelectorAll('[data-testid="banner-success"]')]
          .some(node => !node.closest('[hidden],[aria-hidden="true"]')));
        const success = successBanner || (expected && successHeading && !inputs);
        if (inputs || success) {
          loaded = true; ready = true;
          clearTimeout(timeout); loading.hidden = true; unavailable.hidden = true;
          title.classList.add('visually-hidden');
          if (canAutoOpen && autoDue && !success) attemptAutoOpen();
        }
        if (!success) return;
        completed = true;
        panel.dataset.communityState = 'success';
        panel.querySelector('[data-community-success-icon]').hidden = false;
        panel.querySelector('[data-community-forms-continue]').hidden = false;
        container.setAttribute('role', 'status');
        markMember();
        observers.forEach(observer => observer.disconnect());
      };
      scan();
      // A web component may attach its shadow root after its host enters the DOM.
      let retries = 0;
      const discovery = setInterval(() => {
        scan();
        if (loaded || completed || ++retries >= 30) clearInterval(discovery);
      }, 1000);
      window.addEventListener('pagehide', () => { clearInterval(discovery); clearTimeout(timeout); observers.forEach(observer => observer.disconnect()); }, {once:true});
    });
    window.addEventListener('storage', event => {
      if (event.key === key + 'member' && event.newValue === '1') { markMember(); close(); }
    });
    const openFromLocation = () => { if (location.hash === '#community') open(null); };
    window.addEventListener('hashchange', openFromLocation); openFromLocation();
    window.addEventListener('pagehide', () => clearTimeout(timer));
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      if (readMember()) { markMember(); close(); }
      else location.reload();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

